<template>
  <v-text-field
    v-model="displayValue"
    :name="name"
    :error-messages="errorMessages"
    :disabled="disabled"
    :aria-label="ariaLabel"
    :label="label"
    :messages="messages"
    inputmode="numeric"
    variant="outlined"
    density="compact"
    @update:model-value="update"
    @blur="cleanInputChars"
  >
    <template
      v-if="messages && messages.length"
      #message="data"
    >
      <span class="text-warning">{{ data.message }}</span>
    </template>
  </v-text-field>
</template>
<script>
export default {
  name: "IntegerTextField",
  props: {
    value: {
      validator: prop => typeof prop === "number" || typeof prop === "string" || prop === null || prop === undefined,
      required: true
    },
    errorMessages: {
      validator: prop => typeof prop === "string" || prop === null || prop === undefined || Array.isArray(prop)
    },
    disabled: Boolean,
    ariaLabel: String,
    name: String,
    label: String,
    messages: {
      validator: prop => typeof prop === "string" || prop === null || prop === undefined || Array.isArray(prop)
    }
  },
  data() {
    return {
      displayValue: ""
    };
  },
  watch: {
    value(value) {
      if (value) {
        this.displayValue = value;
      }
    }
  },
  mounted(){
      if (this.value) {
        this.displayValue = this.value;
      }
  },
  methods: {
    update: function() {
      this.$emit("input", this.displayValue);
    },
    cleanInputChars(){
      const regex = /[^0-9-]/gi;

      this.displayValue = this.displayValue.toString().replace(regex, '');

      const integerValue = parseInt(this.displayValue, 10);
      if (integerValue){
        this.displayValue = integerValue.toString();
      }

      this.$emit("input", this.displayValue);
    }
  }
};
</script>